module.exports = __webpack_public_path__ + "static/team_photo-c43aecdf0e8815395a9a01bedcc022ba.jpg";